<template>
  <div class="disclaimer-toast">
    <div class="toast-content">
      <div class="info-icon">
        <img src="~/assets/icons/info-circle.svg" alt="info" />
      </div>
      <span class="toast-text">Доступно только для авторизованных работодателей</span>
      <button class="close-button" @click="emit('close')">
        <img :src="require('~/assets/icons/xmark-white.svg')" alt="delete" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const emit = defineEmits<{
    (e: 'close'): void
  }>()
</script>

<style lang="scss" scoped>
  .disclaimer-toast {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    width: 420px;
    max-width: calc(100% - 32px);
    height: auto;

    @include vp-1439 {
      width: 380px;
      max-width: calc(100% - 40px);
    }

    @include vp-767 {
      width: calc(100% - 32px);
      max-width: 380px;
    }

    > .toast-content {
      display: flex;
      align-items: center;
      gap: 12px;
      background: #414242;
      border-radius: 12px;
      padding: 10px;
      box-shadow: 0 8px 24px rgb(0 0 0 / 12%);
      width: 100%;
      box-sizing: border-box;

      @include vp-767 {
        padding: 12px 16px;
        gap: 8px;
      }

      > .info-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
      }

      > .toast-text {
        font-family: Onest, sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.4;
        color: #fff;
        flex: 1;
      }

      > .close-button {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 28px;
        height: 28px;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;

        &:hover {
          background: rgb(255 255 255 / 10%);
        }
      }
    }
  }
</style>
